import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import LayoutBanner from "../components/Layout/LayoutBanner";
import {
  Alert,
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import AddIco from "../assets/AddIco.svg";
import "../css/notification.css";
import deleteIco from "../assets/delete.svg";
import banner from "../assets/banner_notification.png";
import PopupModal from "../components/Modal/PopupModal";
import { useDispatch, useSelector } from "react-redux";
import {
  addEmail,
  deleteEmail,
  getEmail,
  reset,
} from "../redux/slices/notificationSlice";
import Loader from "../components/Loader/Loader";
import api from "../Api";

const NotificationConfig = () => {
  const authData = useSelector((state) => state.auth.data);
  const notificationData = useSelector((state) => state.notification.data);
  const notificationSuccess = useSelector(
    (state) => state.notification.isSuccess
  );
  const isLoading = useSelector((state) => state.notification.isLoading);
  const dispatch = useDispatch();
  const [emailList, setEmailList] = useState([]);
  const [confirm, setConfirm] = useState({ status: false, data: {} });
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setSuccess(notificationSuccess);
    setTimeout(() => {
      setSuccess(false);
      setMessage("");
      dispatch(reset());
    }, 3500);
  }, [dispatch, notificationSuccess]);

  useEffect(() => {
    const sortedEmailData = [...notificationData].sort((a, b) => {
      if (a.status === "primary" && b.status !== "primary") {
        return -1;
      }
      if (a.status !== "primary" && b.status === "primary") {
        return 1;
      }
      return 0;
    });
    setEmailList(sortedEmailData);
  }, [notificationData]);

  useEffect(() => {
    if (authData.access_token !== "") {
      api.defaults.headers.common.Authorization = authData?.access_token
        ? `Bearer ${authData?.access_token}`
        : "";
      dispatch(getEmail(authData.user_id));
    }
  }, [dispatch, authData]);

  const handleAddEmail = () => {
    setEmailList([
      ...emailList,
      { id: Date.now(), email: "", status: "secondary", isTemporary: true },
    ]);
  };

  const handleEmailChange = (id, value) => {
    let found = emailList.some((v) => v.email === value);
    if (found) {
      setError(true);
      setMessage("Email already exists");
      setTimeout(() => {
        setError(false);
      }, 3000);
    } else {
      setEmailList(
        emailList.map((email) =>
          email.id === id ? { ...email, email: value } : email
        )
      );
    }
  };

  const handleDeleteEmail = (id) => {
    setMessage("Email deleted successfully");
    dispatch(deleteEmail({ id, userId: authData.user_id }));
    setConfirm({ status: false, data: {} });
  };
  const handleSubmit = () => {
    let filtered = emailList.filter((email) => email.email !== authData.email);
    let emails = filtered.map((email) => email.email);
    let checkEmail = filtered.filter((email) => email.email === "");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(emails[emails.length - 1]);
    if (checkEmail.length === 0) {
      if (isValid) {
        setMessage("Email address added successfully");
        dispatch(
          addEmail({
            email: emails[emails.length - 1],
            user_id: authData.user_id,
          })
        );
      } else {
        setError(true);
        setMessage("Enter valid email address");
        setTimeout(() => {
          setMessage("");
          setError(false);
        }, 3000);
      }
    } else {
      setError(true);
      setMessage("Enter email address");
      setTimeout(() => {
        setError(false);
        setMessage("");
      }, 3000);
    }
  };

  const handleClose = () => {
    setConfirm({ status: false, data: {} });
  };

  return (
    <Layout>
      <LayoutBanner
        title="Notification Configuration"
        body={
          "Allows the user to add additional email addresses to facilitate the recipients to receive the notification about the update that has been scheduled"
        }
        image={banner}
      />
      <Loader message={"Loading"} show={isLoading} />

      <Box component="div" mt={2} className="card" height={"min-content"} p={3}>
        <Box
          component={"div"}
          position={"relative"}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Typography fontSize={20} fontWeight={500}>
            Registered Email ID
          </Typography>
          {error ? (
            <Alert variant="filled" severity="error">
              {message}
            </Alert>
          ) : null}
          {success ? (
            <Alert variant="filled" severity="success">
              {message}
            </Alert>
          ) : null}
        </Box>

        <Grid container marginTop={2}>
          <Grid item md={6}>
            <Box component={"div"}>
              {emailList.length > 0 ? (
                <>
                  {emailList.map((email, index) => (
                    <Box
                      key={email.id}
                      width={"100%"}
                      my={1}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"start"}
                      mt={1}
                      className="emailList"
                    >
                      <Box
                        variant="div"
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        width={"100%"}
                      >
                        <Typography
                          textAlign={"start"}
                          fontSize={20}
                          fontWeight={400}
                        >
                          Email ID:
                        </Typography>
                        {email.status === "primary" && (
                          <Typography className="badge" textAlign={"center"}>
                            Primary
                          </Typography>
                        )}
                      </Box>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        width="100%"
                      >
                        <TextField
                          fullWidth
                          margin="dense"
                          value={email.email}
                          disabled={email.status === "primary"} // Disable input if primary
                          onChange={(e) =>
                            handleEmailChange(email.id, e.target.value)
                          }
                          sx={{
                            background:
                              email.status === "primary"
                                ? ""
                                : "none !important",
                          }}
                          placeholder="Enter email address"
                          InputProps={{
                            endAdornment: (
                              <IconButton
                                sx={{
                                  display:
                                    email.status === "primary"
                                      ? "none"
                                      : "block",
                                }}
                                onClick={() => {
                                  console.log(email);
                                  if (
                                    email.email !== "" &&
                                    email?.isTemporary !== true
                                  ) {
                                    setConfirm({ status: true, data: email });
                                  } else {
                                    setEmailList(
                                      emailList.filter(
                                        (item) => item.id !== email.id
                                      )
                                    );
                                  }
                                }}
                              >
                                <img src={deleteIco} alt="delete" />
                              </IconButton>
                            ),
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </>
              ) : (
                <Typography variant="subtitle2" fontSize={"15px"} mt={"50px"}>
                  No Emails Found
                </Typography>
              )}
            </Box>
          </Grid>

          <Grid
            md={6}
            item
            display={"flex"}
            justifyContent={"center"}
            alignItems={"start"}
          >
            <Button
              className="noti_btn"
              variant="contained"
              size="large"
              onClick={handleAddEmail}
            >
              <img src={AddIco} style={{ marginRight: "10px" }} alt="Add" /> Add
              Email ID
            </Button>
          </Grid>
        </Grid>
        {emailList.length !== notificationData.length && (
          <Grid item md={12}>
            <Box
              component={"div"}
              display={"flex"}
              width={"50%"}
              justifyContent={"center"}
              alignItems={"center"}
              bgcolor={"#fff"}
            >
              <Button
                className="save"
                onClick={handleSubmit}
                variant="contained"
                size="large"
              >
                Save
              </Button>
            </Box>
          </Grid>
        )}
      </Box>
      <PopupModal
        open={confirm.status}
        card_width={500}
        handleClose={handleClose}
        content={
          <Box className="card" p={3}>
            <Typography
              variant="h6"
              color={"#CF1E21"}
              fontSize={"20px"}
              fontWeight={700}
              textAlign={"center"}
            >
              Are you Sure?
            </Typography>
            <Typography
              variant="h6"
              fontWeight={500}
              textAlign={"center"}
              mt={2}
              fontSize={"16px"}
            >
              Do you want to delete this Email ID
            </Typography>
            <Typography
              variant="h6"
              fontWeight={400}
              textAlign={"center"}
              fontSize={"16px"}
              color={"#1E8FCF"}
              mt={1}
            >
              {confirm.data.email}
            </Typography>
            <Box
              variant="div"
              display={"flex"}
              justifyContent={"center"}
              my={3}
            >
              <button
                className="btn_cancel w-25 btn"
                variant="contained"
                size="large"
                onClick={() => {
                  setConfirm({ status: false, data: {} });
                }}
              >
                Cancel
              </button>
              <button
                variant="contained"
                className="w-25 btn_yes btn"
                size="large"
                onClick={() => {
                  handleDeleteEmail(confirm.data.id);
                }}
              >
                Yes
              </button>
            </Box>
          </Box>
        }
      />
    </Layout>
  );
};

export default NotificationConfig;
